<template>
  <v-main style="background: #f6f8fa;">
    <v-container fluid>
    <v-row>
          <SaCounts></SaCounts>
    </v-row>
    </v-container>
    <div class="chart_data">
      <div id="chart"></div>
    </div>
  </v-main>

  <!-- partial -->
</template>

<script>
import SaCounts from "./dashboardcount.vue";
import axios from "axios";

export default {
  name: "HomePage",
  data() {
    return {
      isLoading: false,
      roleId: "",
      counts: {},
    };
  },

  components: {
    SaCounts,
  },
  async mounted() {
    // await this.getData();
  },

  methods: {
    async getData() {
      let response = await axios.get(`/admin_dashboard`);
      console.log(response);
      this.counts = response.data;
      console.log(this.counts.totalUser);
    },
  },
};
</script>